import React from "react";
import { FormGroup, Label, Input, Row, Col } from "reactstrap";

export const INITIAL_DISCOUNT = {
    enableDiscount: false,
    discountType: "",
    discountValue: "",
};

export const validateDiscountFields = (discount, toast) => {
    if (!discount?.enableDiscount) {
        return true;
    }
    if (!discount.discountType) {
        toast.error("Discount Type is required!");
        return false;   
    }
    if (
        discount.discountValue === "" ||
        discount.discountValue === null ||
        discount.discountValue === undefined
    ) {
        toast.error("Discount Value is required!");
        return false;
    }
    if (!/^\d+(\.\d+)?$/.test(String(discount.discountValue).trim())) {
        toast.error("Discount Value must be a valid number!");
        return false;
    }
    const value = Number(discount.discountValue);
    if (discount.discountType === "percentage") {
        if (value < 1 || value > 100) {
            toast.error("Discount Value must be between 1 and 100!");
            return false;
        }
    } else if (discount.discountType === "fixed") {
        if (value <= 0) {
            toast.error("Discount Value must be a positive number!");
            return false;
        }
    }
    return true;
};

export const appendDiscountToForm = (form, discount) => {
    const enabled = Boolean(discount?.enableDiscount);
    form.append("enable_discount", enabled);
    // Multipart FormData cannot carry real null; empty string is intended as null
    form.append("discount_type", enabled ? discount.discountType : "");
    form.append(
        "discount_value",
        enabled && discount.discountValue !== ""
            ? Number(discount.discountValue)
            : ""
    );
};

export const mapDiscountFromItem = (item) => {
    const enabled =
        item?.isdiscount === true ||
        item?.isdiscount === 1 ||
        item?.isdiscount === "1" ||
        item?.enable_discount === true ||
        item?.enable_discount === 1 ||
        item?.enable_discount === "1";
    const type = item?.discountType || item?.discount_type || "";
    const value =
        item?.discountValue ??
        item?.discount_value ??
        "";
    return {
        enableDiscount: enabled,
        discountType: type,
        discountValue: value !== null && value !== undefined ? String(value) : "",
    };
};

export const getDiscountStatusLabel = (isdiscount) =>
    isdiscount === 1 || isdiscount === true || isdiscount === "1"
        ? "Active"
        : "Deactive";

const DiscountFields = ({
    enableDiscount,
    discountType,
    discountValue,
    onChange,
}) => {
    const handleEnableChange = (e) => {
        const checked = e.target.checked;
        if (!checked) {
            onChange({
                enableDiscount: false,
                discountType: "",
                discountValue: "",
            });
            return;
        }
        onChange({ enableDiscount: true });
    };

    return (
        <>
            <FormGroup>
                <Label className="d-flex align-items-center">
                    <Input
                        type="checkbox"
                        checked={enableDiscount === true}
                        onChange={handleEnableChange}
                        className="me-2"
                    />
                    Enable Discount
                </Label>
            </FormGroup>
            {enableDiscount === true && (
                <Row>
                    <Col xs={12} md={6}>
                        <FormGroup>
                            <Label className="fw-bold">Discount Type</Label>
                            <Input
                                type="select"
                                name="discountType"
                                value={discountType}
                                onChange={(e) =>
                                    onChange({ discountType: e.target.value })
                                }
                            >
                                <option value="">Select Discount Type</option>
                                <option value="percentage">Percentage (%)</option>
                                <option value="fixed">Fixed Price</option>
                            </Input>
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={6}>
                        <FormGroup>
                            <Label className="fw-bold">Discount Value</Label>
                            <Input
                                type="number"
                                name="discountValue"
                                value={discountValue}
                                min={discountType === "percentage" ? 1 : 0}
                                max={
                                    discountType === "percentage"
                                        ? 100
                                        : undefined
                                }
                                step="any"
                                onChange={(e) =>
                                    onChange({ discountValue: e.target.value })
                                }
                            />
                        </FormGroup>
                    </Col>
                </Row>
            )}
        </>
    );
};

export default DiscountFields;
